/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';

class HeartBeat extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // this.removePreLoader();
    }

    removePreLoader = () => {
        const loader = document.querySelector('.pre-loader');
        const root = document.querySelector('.ct-bids');
        loader.classList.add('hide-loader');
        root.classList.add('loaded');
    }

    render() {
        return (
            <div className={`d-flex justify-content-center h-100`}>
                <div className="loader d-flex flex-column align-items-center justify-content-center h-100">
                    <img src={`${process.env.PUBLIC_URL}/static/images/sellerhomepageimage_1.png`} alt="ctbids-alive" style={{ width: "50%", height: "auto" }} />
                    <p style={{ fontSize: "3.0vh", marginTop: "10px" }}>Greetings!! CTBids.com is live</p>
                </div>
            </div>
        )
    }
}

export default HeartBeat;